export default "__VITE_ASSET__BtZFfjur__"